import step1Icon from '../../../assets/stepsReturnsPe/step1.svg';
import step2Icon from '../../../assets/stepsReturnsPe/step2.svg';
import step3Icon from '../../../assets/stepsReturnsPe/step3.svg';
import step4Icon from '../../../assets/stepsReturnsPe/step4.svg';
import step5Icon from '../../../assets/stepsReturnsPe/step5.svg';

export const stepsReturns = [
  {
    step: '1.',
    text: "Ingresa a D'vuelve R pulsando el botón de “Inicia tu devolución",
    icon: step1Icon,
  },
  {
    step: '2.',
    text:
      'Ingresa los datos de tu compra, selecciona los productos que quieras devolver y el método de devolución',
    icon: step2Icon,
  },
  {
    step: '3.',
    text:
      'Acércate a cualquiera de nuestras tiendas con tus productos y tu código QR',
    icon: step3Icon,
  },
  {
    step: '4.',
    text: 'Presenta el QR al personal de seguridad para validar el ingreso',
    icon: step4Icon,
  },
  {
    step: '5.',
    text:
      "Devuelve tus productos en el centro de devolución D'vuelve R utilizando tu QR",
    icon: step5Icon,
  },
];
